module.exports = __webpack_public_path__ + "static/media/pumpkin.45166ff4.png";